var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCrown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.5,
  d: "m22.961 9.21-2.555 9.798a1.33 1.33 0 0 1-1.287.992H4.885a1.335 1.335 0 0 1-1.286-.992L1.044 9.209a1.32 1.32 0 0 1 .4-1.323 1.33 1.33 0 0 1 1.364-.248L7.04 9.262a.215.215 0 0 0 .247-.067l3.666-4.682a1.324 1.324 0 0 1 1.632-.378c.182.089.34.218.464.378l3.667 4.682a.214.214 0 0 0 .246.066l4.234-1.623a1.344 1.344 0 0 1 1.743.858c.072.231.08.478.021.713"
})));
export default SvgCrown;